const initialState = {
  category: [],
  author: [],
  titleFilter: "",
};

export default initialState;
